import { useQResourceContext } from '../../../../QLayouts/QResourceRoutes/context';
import { useQuery } from 'react-query';
import { QriDetailsResponse } from './types';

type UseQRIResolveType = {
  isLoading: boolean;
  data?: QriDetailsResponse['data']['items'];
};

export const useQriResolve = (qris: string[]): UseQRIResolveType => {
  const { qriClient } = useQResourceContext();

  const response = useQuery({
    queryFn: async () =>
      QriDetailsResponse.parse(
        (await qriClient.post('/details?metadata=true', { qris })).data,
      ).data.items,
    queryKey: ['QriDetails', ...qris],
    enabled: !!qris.length,
  });

  return { isLoading: response.isLoading, data: response.data };
};
